import React, { ReactNode } from 'react'
import { Button } from '@shopflo/ui'
import { ShopfloImageDomain } from 'src/lib/utils/constants'

interface ToggleButtonProps {
  isActive: boolean
  onClick: () => void
  label: string
  icon?: ReactNode
  iconName?: string
  disabled?: boolean
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ isActive, onClick, label, icon, iconName, disabled }) => {
  return (
    <Button
      variant='ghost'
      size='sm'
      onClick={onClick}
      disabled={disabled}
      className={`flex-1 flex justify-start items-center gap-2 h-12 px-1.5 !rounded-xl bg-white transition-all hover:!bg-white ${
        isActive
          ? 'border-[1.5px] border-zinc-500 shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05),0px_0px_0px_1px_rgba(10,13,18,0.05)]'
          : 'border border-transparent shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05),0px_0px_0px_1px_rgba(10,13,18,0.05)]'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <span className='flex items-center gap-2 w-full'>
        <span className='w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0'>
          {icon ? (
            icon
          ) : iconName ? (
            <span className='w-8 h-8'>
              <img src={`${ShopfloImageDomain}/${iconName}.svg`} alt={label} className='w-full h-full object-contain' />
            </span>
          ) : null}
        </span>
        <span className='text-sm font-medium text-zinc-500'>{label}</span>
      </span>
    </Button>
  )
}

export default ToggleButton
